import React, { useState } from "react";
import "../styles/Home.css";
import education1  from "../assets/galleryimg1.avif";
import education2 from "../assets/galleryimg2.avif";
import education3 from "../assets/galleryimg3.avif";
import education4 from "../assets/galleryimg4.avif";
import heroside from "../assets/home-side.jfif";
import Gallery from "./Gallery";
import whoweare from "../assets/who-we-are.avif";
import vision  from "../assets/vision.avif";
import mission from "../assets/mission.avif";
import healthcaredelivery from "../assets/galleryimg2.avif";

const Home = () => {
    const [selectedSector, setSelectedSector] = useState(null);
    /* =====================================================
       CSR SLIDER DATA
    ===================================================== */



    /* =====================================================
       CSR STATE
    ===================================================== */

    const [activeCategory, setActiveCategory] = useState(0);
    const [activeImage, setActiveImage] = useState(0);


    /* =====================================================
       CATEGORY CHANGE
    ===================================================== */

    const changeCategory = (index) => {
        setActiveCategory(index);
        setActiveImage(0);
    };


    /* =====================================================
       IMAGE CHANGE
    ===================================================== */

    const changeImage = (index) => {
        setActiveImage(index);
    };


    return (
        <>

            {/* =====================================================
                HERO SECTION
            ===================================================== */}

            <section className="hero-section" id="home">

                <div className="hero-glow hero-glow-one"></div>
                <div className="hero-glow hero-glow-two"></div>

                <div className="hero-grid"></div>

                <div className="hero-container">

                    <div className="hero-content">

                        <div className="registration-badge">

                            <span className="sparkle-icon">
                                ✧
                            </span>

                            <span>
                                International NGO Project registered in India
                            </span>

                        </div>


                        <h1 className="hero-title">

                            <span className="title-white">
                                Elevating Healthcare
                            </span>

                            <span className="title-blue">
                                Standards &amp; Services
                            </span>

                            <span className="title-white">
                                across India
                            </span>

                        </h1>


                        <p className="hero-description">

                            Universal Health Coverage Strives (UHCS) operates on the
                            foundation of international JCI and national NABH standards
                            to deliver continuous healthcare upskilling, accreditation
                            guidance, and affordable health for all.

                        </p>


                        <div className="hero-actions">

                            <a
                                href="#sectors"
                                className="hero-button hero-button-primary"
                            >
                                <span>
                                    Explore Working Sectors
                                </span>

                                <span className="button-arrow">
                                    →
                                </span>

                            </a>


                            <a
                                href="#action-plan"
                                className="hero-button hero-button-secondary"
                            >
                                <span>
                                    Action Plan 2035
                                </span>

                                <span className="award-icon">
                                    ♙
                                </span>

                            </a>

                        </div>


                        <div className="hero-bottom-line">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                    </div>


                    {/* RIGHT VISUAL */}

                    <div className="hero-visual">

                        <div className="hero-image-wrapper">

                            <img
                                src={heroside}
                                alt="Healthcare professional"
                                className="hero-image"
                            />

                            <div className="hero-image-overlay"></div>


                            <div className="hero-quality-card">

                                <div className="hero-quality-icon">
                                    ✓
                                </div>

                                <div className="hero-quality-content">

                                    <span className="hero-quality-label">
                                        QUALITY HEALTHCARE
                                    </span>

                                    <strong>
                                        Affordable &amp; Accessible Health For All
                                    </strong>

                                </div>

                            </div>

                        </div>


                        <div className="registered-card">

                            <div className="registered-check">
                                ✓
                            </div>

                            <div className="registered-content">

                                <strong>
                                    UHC Registered
                                </strong>

                                <span>
                                    Joint Quality Mission
                                </span>

                            </div>

                        </div>


                        <div className="roadmap-card">

                            <div className="roadmap-label">
                                2035 Roadmap Target
                            </div>

                            <strong>
                                1 Crore Skilled
                            </strong>

                            <span>
                                Healthcare Professionals
                            </span>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                STATS SECTION
            ===================================================== */}

            <section className="stats-section">

                <div className="stats-container">

                    <div className="stat-item">

                        <div className="stat-icon hospital-icon">

                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                            >
                                <rect
                                    x="6"
                                    y="3"
                                    width="12"
                                    height="18"
                                    rx="2"
                                />

                                <path d="M9 7h6" />
                                <path d="M9 11h2" />
                                <path d="M13 11h2" />
                                <path d="M9 15h2" />
                                <path d="M13 15h2" />
                                <path d="M10 21v-3h4v3" />

                            </svg>

                        </div>

                        <div className="stat-content">

                            <strong>
                                350+
                            </strong>

                            <span>
                                Hospitals Empowered
                            </span>

                        </div>

                    </div>


                    <div className="stat-item">

                        <div className="stat-icon education-icon">

                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                            >
                                <path d="M3 9l9-5 9 5-9 5-9-5Z" />
                                <path d="M7 11v5c3 2 7 2 10 0v-5" />
                                <path d="M21 9v6" />
                            </svg>

                        </div>

                        <div className="stat-content">

                            <strong>
                                1.2 Lakh+
                            </strong>

                            <span>
                                Nurses &amp; Staff Trained
                            </span>

                        </div>

                    </div>


                    <div className="stat-item">

                        <div className="stat-icon target-icon">

                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                            >
                                <circle
                                    cx="12"
                                    cy="12"
                                    r="9"
                                />

                                <circle
                                    cx="12"
                                    cy="12"
                                    r="5"
                                />

                                <circle
                                    cx="12"
                                    cy="12"
                                    r="1.5"
                                />

                            </svg>

                        </div>

                        <div className="stat-content">

                            <strong>
                                1 Crore
                            </strong>

                            <span>
                                Target Skilled Staff by 2035
                            </span>

                        </div>

                    </div>


                    <div className="stat-item">

                        <div className="stat-icon quality-icon">

                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                            >

                                <path d="M12 3l7 3v5c0 4.8-3 8-7 10-4-2-7-5.2-7-10V6l7-3Z" />

                                <path d="m9 12 2 2 4-5" />

                            </svg>

                        </div>

                        <div className="stat-content">

                            <strong>
                                100%
                                <br />
                                JCI/NABH
                            </strong>

                            <span>
                                Quality Standards Covered
                            </span>

                        </div>

                    </div>

                </div>

            </section>


            <section
                className="about-section"
                id="about"
            >

                <div className="about-container">

                    <div className="section-label">
                        ABOUT UNIVERSAL HEALTH COVERAGE STRIVES
                    </div>


                    <h2 className="about-title">

                        Dedicated to Healthcare Quality

                        <br className="desktop-break" />

                        &amp; Safety

                    </h2>


                    <p className="about-description">

                        UHCS is an international NGO initiative registered
                        in India designed to bridge standards,

                        <br className="desktop-break" />

                        empower paramedical workforce, and streamline
                        hospital operations.

                    </p>

                </div>

            </section>
            {/* =====================================================
                HEALTHCARE DELIVERY SECTION
            ===================================================== */}

            <section className="healthcare-delivery-section" id="sectors">

                <div className="healthcare-delivery-container">

                    <div className="healthcare-delivery-card">

                        {/* LEFT IMAGE */}
                        <div className="healthcare-delivery-image-wrap">

                            <img
                                src={healthcaredelivery}
                                alt="Healthcare delivery and medical services"
                                className="healthcare-delivery-image"
                            />

                            <div className="healthcare-delivery-image-overlay"></div>

                            <div className="healthcare-delivery-image-content">

                                <span className="healthcare-delivery-badge">
                                    STANDARDIZATION
                                </span>

                                <h3>
                                    Bridging Indian Healthcare to
                                    International Benchmarks
                                </h3>

                            </div>

                        </div>


                        {/* RIGHT CONTENT */}
                        <div className="healthcare-delivery-content">

                            <span className="healthcare-delivery-label">
                                HEALTHCARE QUALITY
                            </span>

                            <h2>
                                Strengthening Healthcare Delivery
                                Systems Across All Tiers
                            </h2>

                            <p>
                                Universal Health Coverage Strives operates
                                across India to ensure every healthcare
                                worker, hospital administrator, and nursing
                                professional is aligned with international
                                accreditation guidelines (Joint Commission
                                International) and national NABH protocols.
                            </p>


                            <div className="healthcare-delivery-points">

                                <div className="healthcare-delivery-point">

                                    <div className="delivery-point-icon">
                                        ✓
                                    </div>

                                    <div>
                                        <strong>
                                            International Accreditation Framework
                                        </strong>

                                        <span>
                                            Structuring hospital workflows according
                                            to JCI and NABH quality benchmarks.
                                        </span>
                                    </div>

                                </div>


                                <div className="healthcare-delivery-point">

                                    <div className="delivery-point-icon">
                                        ♙
                                    </div>

                                    <div>
                                        <strong>
                                            Paramedical Staff Upskilling
                                        </strong>

                                        <span>
                                            Empowering nurses and lab technicians
                                            through certified CME/CNE programs.
                                        </span>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                WHO WE ARE / VISION / MISSION
            ===================================================== */}

            <section className="uhcs-info-section" id="about">

                <div className="uhcs-info-container">

                    {/* WHO WE ARE */}
                    <article className="uhcs-info-card">

                        <div className="uhcs-info-image-wrap">

                            <img
                                src={whoweare}
                                alt="Healthcare hospital infrastructure"
                                className="uhcs-info-image"
                            />

                            <div className="uhcs-info-icon">
                                ▣
                            </div>

                        </div>

                        <div className="uhcs-info-content">

                            <h3>
                                Who We Are
                            </h3>

                            <p>
                                Universal Health Coverage Strives (UHCS) is
                                an international NGO initiative registered in
                                India. We operate on UHC principles to enhance
                                hospital standards and allied medical practices.
                            </p>

                        </div>

                    </article>


                    {/* OUR VISION */}
                    <article className="uhcs-info-card">

                        <div className="uhcs-info-image-wrap">

                            <img
                                src={vision}
                                alt="Healthcare professional"
                                className="uhcs-info-image"
                            />

                            <div className="uhcs-info-icon vision-icon">
                                ◉
                            </div>

                        </div>

                        <div className="uhcs-info-content">

                            <h3>
                                Our Vision
                            </h3>

                            <p>
                                To establish a robust healthcare environment
                                across India where standard-driven,
                                high-quality medical care is universally
                                accessible and affordable for every citizen.
                            </p>

                        </div>

                    </article>


                    {/* OUR MISSION */}
                    <article className="uhcs-info-card">

                        <div className="uhcs-info-image-wrap">

                            <img
                                src={mission}
                                alt="Medical stethoscope"
                                className="uhcs-info-image"
                            />

                            <div className="uhcs-info-icon mission-icon">
                                ◎
                            </div>

                        </div>

                        <div className="uhcs-info-content">

                            <h3>
                                Our Mission
                            </h3>

                            <p>
                                To continuously drive quality improvement,
                                re-skill healthcare professionals, resolve
                                hospital scheme bottlenecks, and deliver
                                international-level training certification.
                            </p>

                        </div>

                    </article>

                </div>

            </section>
            {/* =====================================================
    OUR 8 WORKING SECTORS
===================================================== */}

<section className="working-sectors-section" id="sectors">

    <div className="working-sectors-container">

        {/* HEADER */}
        <div className="working-sectors-header">

            <div className="working-sectors-heading">

                <span className="working-sectors-eyebrow">
                    CORE DOMAIN COVERAGE
                </span>

                <h2>
                    Our 8 Working Sectors
                </h2>

                <p>
                    Explore how UHCS actively impacts healthcare quality,
                    education, government recovery, and workforce protection.
                </p>

            </div>


            {/* FILTERS */}
            <div className="working-sector-filters">

                {[
                    "All",
                    "Standards",
                    "Education",
                    "Training",
                    "Finance & Schemes",
                    "Welfare"
                ].map((filter, index) => (

                    <button
                        key={filter}
                        className={`sector-filter ${
                            index === 0 ? "active" : ""
                        }`}
                        type="button"
                    >
                        {filter}
                    </button>

                ))}

            </div>

        </div>


        {/* SECTOR GRID */}
        <div className="working-sectors-grid">

            {[
    {
        number: "01",
        category: "JCI & NABH Standards",
        title: "Hospital Services Improvement",
        description:
            "Upgrading hospital operational standards, clinical governance, and infection control to meet international benchmarks.",
        image: "/images/healthcare-delivery.jpg",
        focusPoints: [
            "JCI & NABH accreditation alignment",
            "Clinical governance improvement",
            "Hospital quality management systems",
            "Infection prevention and control"
        ]
    },
    {
        number: "02",
        category: "Global Curriculum",
        title: "International Healthcare Education",
        description:
            "Advancing healthcare education programs with global standard curriculums, modern practical learning and professional development.",
        image: education1,
        focusPoints: [
            "Global medical certification alignment",
            "Simulation lab training standards",
            "Cross-border educational workshops",
            "Evidence-based nursing modules"
        ]
    },
    {
        number: "03",
        category: "Skill Development",
        title: "Paramedical Staff Re-skilling",
        description:
            "Continuous upskilling and re-skilling programs designed for allied health professionals, technicians, and support teams.",
        image: education2,
        focusPoints: [
            "Allied healthcare skill development",
            "Technical competency programs",
            "Practical hands-on training",
            "Continuous professional development"
        ]
    },
    {
        number: "04",
        category: "Hospital Assistance",
        title: "Government Schemes & Payment Recovery",
        description:
            "Helping Indian hospitals navigate government health schemes and systematic payment recovery processes.",
        image: education3,
        focusPoints: [
            "Government healthcare scheme support",
            "Hospital claim documentation",
            "Payment recovery assistance",
            "Process and compliance guidance"
        ]
    },
    {
        number: "05",
        category: "Financial Support",
        title: "Insurance Claim Recovery",
        description:
            "Assisting hospitals and healthcare providers in resolving stalled insurance claims, disputes, and payment delays.",
        image: education4,
        focusPoints: [
            "Insurance claim documentation",
            "Delayed claim resolution",
            "Claim dispute assistance",
            "Payment recovery processes"
        ]
    },
    {
        number: "06",
        category: "International Certification",
        title: "CME & CNE Training Programs",
        description:
            "Organizing Continuing Medical Education (CME) and Continuing Nursing Education (CNE) workshops and certification programs.",
        image: "/images/vision.jpg",
        focusPoints: [
            "CME certification programs",
            "CNE educational workshops",
            "International faculty sessions",
            "Professional certification pathways"
        ]
    },
    {
        number: "07",
        category: "Worker Protection",
        title: "Social Security for Paramedical Staff",
        description:
            "Advocating and implementing social security, health insurance coverage, workplace safety, and welfare programs.",
        image: "/images/mission.jpg",
        focusPoints: [
            "Social security awareness",
            "Health insurance coverage",
            "Workplace safety programs",
            "Paramedical staff welfare"
        ]
    },
    {
        number: "08",
        category: "Multi-Discipline Synergy",
        title: "Joint Training Initiatives",
        description:
            "Facilitating inter-disciplinary joint training sessions among doctors, nurses, and administrative staff.",
        image: "/images/who-we-are.jpg",
        focusPoints: [
            "Doctor and nurse joint training",
            "Inter-disciplinary workshops",
            "Hospital administration training",
            "Collaborative healthcare learning"
        ]
    }
].map((sector) => (

                <article
                    className="working-sector-card"
                    key={sector.number}
                >

                    {/* IMAGE */}
                    <div className="working-sector-image-wrap">

                        <img
                            src={sector.image}
                            alt={sector.title}
                            className="working-sector-image"
                        />

                        <div className="working-sector-image-overlay"></div>

                        <span className="working-sector-number">
                            #{sector.number} {sector.category}
                        </span>

                    </div>


                    {/* CONTENT */}
                    <div className="working-sector-content">

                        <h3>
                            {sector.title}
                        </h3>

                        <p>
                            {sector.description}
                        </p>


                        <button
                            type="button"
                            className="working-sector-link"
                            onClick={() => setSelectedSector(sector)}
                        >
                            <span>View Key Focus Points</span>
                            <span>›</span>
                        </button>

                    </div>

                </article>

            ))}

        </div>

    </div>

</section>

{/* =====================================================
    ACTION PLAN 2035
===================================================== */}

<section className="action-plan-section" id="action-plan">

    <div className="action-plan-container">

        {/* LEFT CONTENT */}
        <div className="action-plan-content">

            <div className="action-plan-badge">
                <span>↗</span>
                STRATEGIC FUTURE ROADMAP
            </div>

            <h2 className="action-plan-title">
                <span>Action Plan - 2035</span>

                <strong>
                    Healthcare Mission Up To
                    <br />
                    2035
                </strong>
            </h2>

            <p className="action-plan-description">
                To meet India's expanding healthcare needs, UHCS has launched
                a unified national working plan aimed at building a world-class
                skilled medical workforce by the year 2035.
            </p>


            {/* PLAN ITEM 01 */}
            <div className="action-plan-item">

                <div className="action-plan-number">
                    01
                </div>

                <div className="action-plan-item-content">

                    <h3>
                        Standardized Paramedical Upskilling
                    </h3>

                    <p>
                        Modernizing clinical training modules across rural and
                        urban healthcare centers.
                    </p>

                </div>

            </div>


            {/* PLAN ITEM 02 */}
            <div className="action-plan-item">

                <div className="action-plan-number action-plan-number-purple">
                    02
                </div>

                <div className="action-plan-item-content">

                    <h3>
                        JCI &amp; NABH Accreditation Support
                    </h3>

                    <p>
                        Guiding hospitals through continuous quality auditing
                        and patient safety protocols.
                    </p>

                </div>

            </div>

        </div>


        {/* RIGHT TARGET CARD */}
        <div className="action-plan-target-card">

            <div className="action-plan-target-icon">
                <span>♙</span>
            </div>

            <span className="action-plan-target-label">
                WORKING PLAN TARGET
            </span>

            <strong className="action-plan-target-number">
                1 Crore
            </strong>

            <h3>
                Skilled Healthcare Professionals
            </h3>

            <span className="action-plan-deadline">
                Goal Deadline: Year 2035
            </span>


            <div className="action-plan-divider"></div>


            <div className="action-plan-images">

                <div className="action-plan-image">
                    <img
                        src="/images/healthcare-delivery.jpg"
                        alt="Healthcare professional"
                    />
                </div>

                <div className="action-plan-image">
                    <img
                        src={education2}
                        alt="Medical professional"
                    />
                </div>

                <div className="action-plan-image">
                    <img
                        src={education3}
                        alt="Healthcare facility"
                    />
                </div>

            </div>

        </div>

    </div>

</section>
<Gallery/>
           {/* =====================================================
    SECTOR OVERVIEW MODAL
===================================================== */}

{selectedSector && (
    <div
        className="sector-modal-backdrop"
        onClick={() => setSelectedSector(null)}
    >
        <div
            className="sector-modal"
            onClick={(e) => e.stopPropagation()}
        >

            {/* HEADER IMAGE */}
            <div className="sector-modal-header">

                <img
                    src={selectedSector.image}
                    alt={selectedSector.title}
                />

                <div className="sector-modal-header-overlay"></div>

                <div className="sector-modal-header-content">

                    <span className="sector-modal-badge">
                        SECTOR #{selectedSector.number}
                    </span>

                    <h2>
                        {selectedSector.title}
                    </h2>

                </div>

                {/* CLOSE BUTTON */}
                <button
                    type="button"
                    className="sector-modal-close"
                    onClick={() => setSelectedSector(null)}
                    aria-label="Close"
                >
                    ×
                </button>

            </div>


            {/* MODAL BODY */}
            <div className="sector-modal-body">

                <p className="sector-modal-description">
                    {selectedSector.description}
                </p>


                <div className="sector-modal-divider"></div>


                <h4 className="sector-modal-section-title">
                    KEY STRATEGIC FOCUS AREAS
                </h4>


                <div className="sector-focus-grid">

                    {selectedSector.focusPoints.map((point, index) => (

                        <div
                            className="sector-focus-item"
                            key={index}
                        >

                            <span className="sector-focus-check">
                                ✓
                            </span>

                            <span>
                                {point}
                            </span>

                        </div>

                    ))}

                </div>


                <div className="sector-modal-footer">

                    <button
                        type="button"
                        className="sector-modal-close-button"
                        onClick={() => setSelectedSector(null)}
                    >
                        Close Overview
                    </button>

                </div>

            </div>

        </div>
    </div>
)} 

        </>
    );
};

export default Home;